'use strict';

export default class LoginController 
{
	/*@ngInject*/
	constructor(Auth, $state, $translate, $log, ValidationService) {
		this.Auth = Auth;
		this.$state = $state;
		this.$translate = $translate;
		this.$log = $log;
		this.validation = new ValidationService();

		Auth.logout(); // Borra la cookie
	}

	login(form) 
	{
		this.error = null;

		if (!this.validation.checkFormValidity(form)) {
			// Con el mensaje de validacion es suficiente
			return;
		}

		this.Auth.login({
			email: this.user.email,
			password: this.user.password
		})
		.then(() => {
			if (this.$state.__from && this.$state.__from.name !== "login" && this.$state.__from.name !== "") {
				this.$state.go(this.$state.__from, this.$state.__fromParams);
			}
			else {
				this.$state.go('home'); // Logged in, redirect to home
			}
		})
		.catch(err => {
			this.$log.warn(err.data);
			this.error = err.data;
		});
	}
}



// WEBPACK FOOTER //
// ./client/app/account/login/login.controller.js